import { ca } from '@cian/analytics';

import { getProducts, TOfferProductsProps } from '../../utils/trackings_helpers';

export function trackSwipeMoveToArchiveClick(offer?: TOfferProductsProps, opponentId?: number) {
  ca('eventSite', {
    action: 'swipe_sopr',
    category: 'Chat',
    label: 'archive',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackSwipeMarkAsReadClick(offer?: TOfferProductsProps, opponentId?: number) {
  ca('eventSite', {
    action: 'swipe_sopr',
    category: 'Chat',
    label: 'read',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackSwipeDeleteClick(offer?: TOfferProductsProps, opponentId?: number) {
  ca('eventSite', {
    action: 'swipe_sopr',
    category: 'Chat',
    label: 'delete',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackSwipeUnblockClick(offer?: TOfferProductsProps, opponentId?: number) {
  ca('eventSite', {
    action: 'swipe_sopr',
    category: 'Chat',
    label: 'unblock',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackSwipeRemoveFromArchiveClick(offer?: TOfferProductsProps, opponentId?: number) {
  ca('eventSite', {
    action: 'swipe_sopr',
    category: 'Chat',
    label: 'restore',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export const trackOpenChatListItemClick = (chatId: string, opponentId?: number | null, ownerId?: number | null) => {
  try {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Chat',
      action: 'Open_sopr',
      label: '',
      page: {
        extra: {
          chat_id: chatId,
          owner_id: ownerId,
          opponent_id: opponentId,
        },
      },
    });
  } catch (error) {
    console.debug('trackOpenChatListItemClick', error);
  }
};
